module.exports = __webpack_public_path__ + "static/media/rabbit.dc11f45d.svg";